import { render } from "./ExtraAdvices.vue?vue&type=template&id=e51936ea"
import script from "./ExtraAdvices.vue?vue&type=script&lang=js"
export * from "./ExtraAdvices.vue?vue&type=script&lang=js"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__